/* eslint-disable no-unused-vars */
export type NeolineContextChangeHandler = () => void

type ListenerRegistration = {
  target: EventTarget | {on: Function; removeListener?: Function}
  event: string
  handler: (...args: unknown[]) => void
  isProviderEvent?: boolean
}

const LEGACY_WINDOW_EVENTS = [
  'NEOLine.N3.EVENT.ACCOUNT_CHANGED',
  'NEOLine.NEOX.EVENT.ACCOUNT_CHANGED',
  'NEOLine.N3.EVENT.NETWORK_CHANGED',
  'NEOLine.NEOX.EVENT.NETWORK_CHANGED',
]

const NEP21_PROVIDER_EVENTS = [
  'accountchanged',
  'networkchanged',
  'NetworkChanged',
]

export const registerNeolineContextListeners = (
  onContextChange: NeolineContextChangeHandler
): (() => void) => {
  const registrations: ListenerRegistration[] = []

  LEGACY_WINDOW_EVENTS.forEach(event => {
    const handler = () => onContextChange()

    window.addEventListener(event, handler)
    registrations.push({target: window, event, handler})
  })

  return () => {
    registrations.forEach(({target, event, handler}) => {
      if ('removeEventListener' in target) {
        target.removeEventListener(event, handler)
      }
    })
  }
}

export const registerNep21ContextListeners = (
  provider: unknown,
  onContextChange: NeolineContextChangeHandler
): (() => void) => {
  const cleanups: Array<() => void> = []

  cleanups.push(registerNeolineContextListeners(onContextChange))

  const nep21Provider = provider as {
    on?: (event: string, handler: (...args: unknown[]) => void) => void
    removeListener?: (
      event: string,
      handler: (...args: unknown[]) => void
    ) => void
  }

  if (typeof nep21Provider?.on !== 'function') {
    return () => cleanups.forEach(cleanup => cleanup())
  }

  NEP21_PROVIDER_EVENTS.forEach(event => {
    try {
      const handler = () => onContextChange()

      nep21Provider.on!(event, handler)
      cleanups.push(() => {
        nep21Provider.removeListener?.(event, handler)
      })
    } catch {
      // Provider may not support this event name.
    }
  })

  return () => cleanups.forEach(cleanup => cleanup())
}
